import { STATUS_LABEL_ENUM } from '../../utils/const';
import { blue, gray, green, pink, red, yellow } from '../Color';
import { CheckCircle } from '../Icons/CheckCircle';
import { ExclamationCircle } from '../Icons/ExclamationCircle';
import { HourGlassCircle } from '../Icons/HourGlassCircle';
import { TimeCircle } from '../Icons/TimeCircle';
import { InfoCircle } from '../Icons/InfoCircle';
import { Ban } from '../Icons/Ban';
import { Historical } from '../Icons/Historical';
import { RecycleBin } from '../Icons/RecycleBin';

export const StatusColor = {
	Pink: pink[7],
	Yellow: yellow[7],
	Green: green[7],
	Red: red[7],
	Blue: blue[7],
	Gray: gray[5],
};

export const statusIcons = {
	[STATUS_LABEL_ENUM.CHECK_MARK_GREEN]: <CheckCircle fill={StatusColor.Green} />,
	[STATUS_LABEL_ENUM.EXCLAMATION_PINK]: <ExclamationCircle fill={StatusColor.Pink} />,
	[STATUS_LABEL_ENUM.SAND_CLOCK_YELLOW]: <HourGlassCircle fill={StatusColor.Yellow} />,
	[STATUS_LABEL_ENUM.CRISS_CROSS_RED]: <TimeCircle fill={StatusColor.Red} />,
	[STATUS_LABEL_ENUM.EXCLAMATION_YELLOW]: <ExclamationCircle fill={StatusColor.Yellow} />,
	[STATUS_LABEL_ENUM.EXCLAMATION_BLUE]: <ExclamationCircle fill={StatusColor.Blue} />,
	[STATUS_LABEL_ENUM.INFO_BLUE]: <InfoCircle fill={StatusColor.Blue} />,
	[STATUS_LABEL_ENUM.ICON_BAN]: <Ban fill={StatusColor.Red} />,
	[STATUS_LABEL_ENUM.ICON_HISTORICAL]: <Historical fill={StatusColor.Yellow} />,
	[STATUS_LABEL_ENUM.RECYCLE_BIN_RED]: <RecycleBin fill={StatusColor.Red} />,
};
